/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unnecessary-type-assertion */
import type {ChangeEvent} from 'react';
import {useState} from 'react';
import {
	Button,
	Form,
	InputGroup,
	OverlayTrigger,
	Tooltip,
} from 'react-bootstrap';
// eslint-disable-next-line import/named
import {confirmAlert} from 'react-confirm-alert';
import {toast} from 'react-toastify';
import {PopoverComponent} from 'components/PopoverComponent';
import FieldSetSumma from 'components/Custom/FieldGroup';

import type {IActionForm, IPccRuleFormStatic, IResetSMSForm} from 'interfaces';

const bitRatePattern =
	/^(\d+\s(?:bps|Kbps|Mbps|Gbps|Tbps)|\$math\((.+)\)|\$[a-zA-Z_][a-zA-Z0-9_]*)$/;

// validations fields
const validationRules = {
	uplink: {
		regex: bitRatePattern,
		errorMessage:
			'Invalid format. Allowed formats: "128 bps|Kbps|Mbps|Gbps|Tbps", "$uplink", or "$math(0.05 * $uplink)".',
	},
	downlink: {
		regex: bitRatePattern,
		errorMessage:
			'Invalid format. Allowed formats: "128 bps|Kbps|Mbps|Gbps|Tbps", "$downlink", or "$math(0.05 * $downlink)".',
	},
	maxbrUl: {
		regex: bitRatePattern,
		errorMessage:
			'Invalid format. Allowed formats: "128 bps|Kbps|Mbps|Gbps|Tbps", "$maxbrUl", or "$math(0.05 * $maxbrUl)".',
	},
	maxbrDl: {
		regex: bitRatePattern,
		errorMessage:
			'Invalid format. Allowed formats: "128 bps|Kbps|Mbps|Gbps|Tbps", "$maxbrDl", or "$math(0.05 * $maxbrDl)".',
	},
	gbrUl: {
		regex: bitRatePattern,
		errorMessage:
			'Invalid format. Allowed formats: "128 bps|Kbps|Mbps|Gbps|Tbps", "$gbrUl", or "$math(0.05 * $gbrUl)".',
	},
	gbrDl: {
		regex: bitRatePattern,
		errorMessage:
			'Invalid format. Allowed formats: "128 bps|Kbps|Mbps|Gbps|Tbps", "$gbrDl", or "$math(0.05 * $gbrDl)".',
	},
};

interface SelectionItemProps {
	formData: IActionForm;
	updateFormData: (
		keyForm: string,
		path: string[],
		value: string,
		type: string,
		checked: boolean,
		key: number | string | null,
		data: string[] | undefined,
	) => void;
	onObserver: (isValid: boolean) => void;
	onAddRuleStatic: () => void;
	onAddResetSMS: () => void;
	onDeleteRuleStatic: (ruleId: string) => void;
	onDeleteResetSMSId: (ruleId: string) => void;
}

const CustomSelectionItemCondition = ({
	formData,
	updateFormData,
	onObserver,
	onAddRuleStatic,
	onAddResetSMS,
	onDeleteRuleStatic,
	onDeleteResetSMSId,
}: SelectionItemProps) => {
	const [isValid, setIsValid] = useState({
		uplink: true,
		downlink: true,
		maxbrUl: true,
		maxbrDl: true,
		gbrUl: true,
		gbrDl: true,
	});

	/**
	 * The function handles changes in form input fields, updating state based on the type of input.
	 * @param e - The parameter "e" is of type ChangeEvent<HTMLInputElement>, which is an event object
	 * that is triggered when the value of an input element changes. It contains information about the
	 * input element that triggered the event, such as its name, value, type, and whether it is checked
	 * (if it is a
	 */
	const handleChange = (
		path: string[],
		e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>,
		key?: number | string | null,
		data?: string[],
	) => {
		const {value, type} = e.target;
		const checked =
			type === 'checkbox' && 'checked' in e.target
				? (e.target as HTMLInputElement).checked
				: false;
		updateFormData(formData.id, path, value, type, checked, key ?? null, data);
	};

	/**
	 * The function `optionsRemoveResetSMS` returns an object with properties for a confirmation modal
	 * dialog, including a title, message, buttons, and various configuration options.
	 */
	const optionsRemoveResetSMS = (id: string) => ({
		title: 'Do you really want to remove all policy names?',
		message: 'The action must be saved for the change to persist.',
		buttons: [
			{
				label: 'Yes',
				onClick: () => {
					try {
						onDeleteResetSMSId(id);
						toast.success('Deleted Successfully!');
					} catch (error) {
						console.error(error);
					}
				},
			},
			{
				label: 'No',
			},
		],
		closeOnEscape: true,
		closeOnClickOutside: true,
		keyCodeForClose: [8, 32],
		overlayClassName: 'overlay-custom-class-name',
	});

	const handleRuleStaticRemove = (id: string) => {
		onDeleteRuleStatic(id);
	};

	const handleResetSMSRemove = (id: string) => {
		confirmAlert(optionsRemoveResetSMS(id));
	};

	return (
		<>
			{/* 1 row */}
			<div
				className="text-bg-light mb-2 &gt; border rounded-3 px-4 pb-3"
				style={{height: '100%', overflowY: 'auto'}}>
				<div className="centered-div mb-2">
					<label htmlFor="filter-list-group" className="centered-label">
						Labels selected
					</label>
				</div>

				{/* 1 row */}
				{formData?.precedence?.active && (
					<div className="row">
						<div className="col-lg-12 bg-gray-400 rounded pt-1 pb-1 mt-2 mb-2 text-center">
							<b>Level Precedence</b>
						</div>
						{formData?.precedence?.active && (
							<div className="col-xs-12 col-sm-6 col-lg-3">
								<label htmlFor="idActionPrece">Precedence</label>
								<InputGroup className="mb-3 w-100" style={{minWidth: '7.5rem'}}>
									<Form.Control
										type="number"
										name="precedence"
										value={formData?.precedence?.value}
										required={formData?.precedence?.active}
										onChange={e => handleChange(['precedence'], e)}
										aria-label="precedence"
									/>
								</InputGroup>
							</div>
						)}
					</div>
				)}
				{/* end 1 row */}

				{/* 1 row */}
				{(formData?.authDefQos?._5qi?.active ||
					formData?.authDefQos?.arp?.priorityLevel?.active ||
					formData?.authDefQos?.arp?.preemptCap?.active ||
					formData?.authDefQos?.arp?.preemptVuln?.active) && (
					<div className="row">
						<div className="col-lg-12 bg-gray-400 rounded pt-1 pb-1 mt-2 mb-2 text-center">
							<b>Auth Def QoS</b>
						</div>
						{formData?.authDefQos?._5qi?.active && (
							<div className="col-xs-12 col-lg-6">
								<label htmlFor="idAction5qi">
									5qi
									<PopoverComponent classes="ml-1" iconSize="1rem">
										<div>
											<h5>5G QoS Identifier (5QI)</h5>
											<p>Similar to the QCI value used for LTE</p>
										</div>
									</PopoverComponent>
								</label>
								<InputGroup className="mb-3">
									<Form.Control
										name="_5qi"
										value={formData?.authDefQos?._5qi?.value}
										required={formData?.authDefQos?._5qi.active}
										onChange={e => handleChange(['authDefQos', '_5qi'], e)}
										aria-label="_5qi"
									/>
								</InputGroup>
							</div>
						)}

						{(formData?.authDefQos?.arp?.priorityLevel?.active ||
							formData?.authDefQos?.arp?.preemptCap?.active ||
							formData?.authDefQos?.arp?.preemptVuln?.active) && (
							<FieldSetSumma title="ARP">
								<div className="row">
									{formData?.authDefQos?.arp?.priorityLevel?.active && (
										<div className="col-xs-12 col-lg-2">
											<label htmlFor="idActionARPPriorityLevel">
												Priority Level
											</label>
											<InputGroup className="mb-3">
												<Form.Control
													type="number"
													onInput={e => {
														const target = e.target as HTMLInputElement;
														target.value = target.value.slice(0, 15);
													}}
													name="priorityLevel"
													value={
														formData?.authDefQos?.arp?.priorityLevel?.value
													}
													required={
														formData?.authDefQos?.arp?.priorityLevel?.active
													}
													onChange={e =>
														handleChange(
															['authDefQos', 'arp', 'priorityLevel'],
															e,
														)
													}
													aria-label="priorityLevel"
												/>
											</InputGroup>
										</div>
									)}

									{formData?.authDefQos?.arp?.preemptCap?.active && (
										<div className="col-xs-12 col-lg-5">
											<label htmlFor="idActionARPPreEmptionCap">
												Pre-emption Capability
											</label>
											<InputGroup className="mb-3">
												<Form.Select
													name="preemptCap"
													value={formData?.authDefQos?.arp?.preemptCap?.value}
													required={
														formData?.authDefQos?.arp?.preemptCap?.active
													}
													onChange={e =>
														handleChange(['authDefQos', 'arp', 'preemptCap'], e)
													}
													aria-label="preemptCap">
													<option disabled value="">
														Select...
													</option>
													<option value="MAY_PREEMPTABLE">
														MAY_PREEMPTABLE
													</option>
													<option value="NOT_PREEMPTABLE">
														NOT_PREEMPTABLE
													</option>
												</Form.Select>
											</InputGroup>
										</div>
									)}

									{formData?.authDefQos?.arp?.preemptVuln?.active && (
										<div className="col-xs-12 col-lg-5">
											<label htmlFor="idActionARPPreEmptionVulne">
												Pre-emption Vulnerability
											</label>
											<InputGroup className="mb-3">
												<Form.Select
													name="preemptVuln"
													value={formData?.authDefQos?.arp?.preemptVuln?.value}
													required={
														formData?.authDefQos?.arp?.preemptVuln?.active
													}
													onChange={e =>
														handleChange(
															['authDefQos', 'arp', 'preemptVuln'],
															e,
														)
													}
													aria-label="preemptVuln">
													<option disabled value="">
														Select...
													</option>
													<option value="NOT_PREEMPTABLE">
														NOT_PREEMPTABLE
													</option>
													<option value="PREEMPTABLE">PREEMPTABLE</option>
												</Form.Select>
											</InputGroup>
										</div>
									)}
								</div>
							</FieldSetSumma>
						)}
					</div>
				)}
				{/* end 1 row */}

				{(formData?.authSessAmbr?.uplink.active ||
					formData?.authSessAmbr?.downlink?.active) && (
					<div className="row">
						<div className="col-lg-12 bg-gray-400 rounded pt-1 pb-1 mt-2 mb-2 text-center">
							<b>AMBR</b>
						</div>
						{formData?.authSessAmbr?.uplink.active && (
							<div className="col-xs-12 col-lg-6">
								<label htmlFor="idActionAMBRUplink">Uplink Bit Rate</label>
								<InputGroup className="mb-3">
									<Form.Control
										name="uplink"
										value={formData?.authSessAmbr?.uplink?.value}
										required={formData?.authSessAmbr?.uplink.active}
										onChange={e => handleChange(['authSessAmbr', 'uplink'], e)}
										onInput={(e: ChangeEvent<HTMLInputElement>) => {
											const {name} = e.target;
											const target = e.target as unknown as HTMLInputElement;
											const val = target.value;
											target.value = val;
											const rule = validationRules[name as never] as any;
											const result = rule.regex.test(val);
											setIsValid(prev => ({
												...prev,
												[name]: result,
											}));
											onObserver(result);
										}}
										placeholder="Ej: 128 Mbps, $uplink o $math(...)"
										aria-label="uplink"
										className={!isValid.uplink ? 'is-invalid' : ''}
									/>
									{!isValid.uplink && (
										<div className="invalid-feedback">
											{validationRules?.uplink?.errorMessage}
										</div>
									)}
								</InputGroup>
							</div>
						)}

						{formData?.authSessAmbr?.downlink?.active && (
							<div className="col-xs-12 col-lg-6">
								<label htmlFor="idActionAMBRdownlink">Downlink Bit Rate</label>
								<InputGroup className="mb-3">
									<Form.Control
										name="downlink"
										value={formData?.authSessAmbr?.downlink?.value}
										required={formData?.authSessAmbr?.downlink?.active}
										onChange={e =>
											handleChange(['authSessAmbr', 'downlink'], e)
										}
										onInput={(e: ChangeEvent<HTMLInputElement>) => {
											const {name} = e.target;
											const target = e.target as unknown as HTMLInputElement;
											const val = target.value;
											target.value = val;
											const rule = validationRules[name as never] as any;
											const result = rule.regex.test(val);
											setIsValid(prev => ({
												...prev,
												[name]: result,
											}));
											onObserver(result);
										}}
										placeholder="Ej: 128 Mbps, $downlink o $math(...)"
										aria-label="downlink"
										className={!isValid.downlink ? 'is-invalid' : ''}
									/>
									{!isValid.downlink && (
										<div className="invalid-feedback">
											{validationRules?.downlink?.errorMessage}
										</div>
									)}
								</InputGroup>
							</div>
						)}
					</div>
				)}

				{(formData?.qosData?._5qi?.active ||
					formData?.qosData?.maxbrUl?.active ||
					formData?.qosData?.maxbrDl?.active ||
					formData?.qosData?.gbrUl?.active ||
					formData?.qosData?.gbrDl?.active ||
					formData?.qosData?.arp?.priorityLevel?.active ||
					formData?.qosData?.arp?.preemptCap?.active ||
					formData?.qosData?.arp?.preemptVuln?.active) && (
					<div className="row">
						<div className="col-lg-12 bg-gray-400 rounded pt-1 pb-1 mt-2 mb-2 text-center">
							<b>QoS Data</b>
						</div>
						{formData?.qosData?._5qi?.active && (
							<div className="col-xs-12 col-lg-4">
								<label htmlFor="idActionQoS5qi">5qi</label>
								<InputGroup className="mb-3">
									<Form.Control
										name="_5qi"
										value={formData?.qosData?._5qi?.value}
										required={formData?.qosData?._5qi?.active}
										onChange={e => handleChange(['qosData', '_5qi'], e)}
										className="w-100"
										aria-label="_5qi"
									/>
								</InputGroup>
							</div>
						)}

						{formData?.qosData?.maxbrUl?.active && (
							<div className="col-xs-12 col-lg-4">
								<label htmlFor="idActionQoSMaxBrU">Max BR Upload</label>
								<InputGroup className="mb-3">
									<Form.Control
										name="maxbrUl"
										value={formData?.qosData?.maxbrUl?.value}
										required={formData?.qosData?.maxbrUl?.active}
										onChange={e => handleChange(['qosData', 'maxbrUl'], e)}
										onInput={(e: ChangeEvent<HTMLInputElement>) => {
											const {name} = e.target;
											const target = e.target as unknown as HTMLInputElement;
											const val = target.value;
											target.value = val;
											const rule = validationRules[name as never] as any;
											const result = rule.regex.test(val);
											setIsValid(prev => ({
												...prev,
												[name]: result,
											}));
											onObserver(result);
										}}
										aria-label="maxbrUl"
										placeholder="Ej: 128 Mbps, $maxbrUl o $math(...)"
										className={!isValid.maxbrUl ? 'is-invalid' : ''}
									/>
									{!isValid.maxbrUl && (
										<div className="invalid-feedback">
											{validationRules.maxbrUl.errorMessage}
										</div>
									)}
								</InputGroup>
							</div>
						)}

						{formData?.qosData?.maxbrDl?.active && (
							<div className="col-xs-12 col-lg-4">
								<label htmlFor="idActionQoSMaxBrD">Max BR Download</label>
								<InputGroup className="mb-3">
									<Form.Control
										name="maxbrDl"
										value={formData?.qosData?.maxbrDl?.value}
										required={formData?.qosData?.maxbrDl?.active}
										onChange={e => handleChange(['qosData', 'maxbrDl'], e)}
										onInput={(e: ChangeEvent<HTMLInputElement>) => {
											const {name} = e.target;
											const target = e.target as unknown as HTMLInputElement;
											const val = target.value;
											target.value = val;
											const rule = validationRules[name as never] as any;
											const result = rule.regex.test(val);
											setIsValid(prev => ({
												...prev,
												[name]: result,
											}));
											onObserver(result);
										}}
										aria-label="maxbrDl"
										placeholder="Ej: 128 Mbps, $maxbrDl o $math(...)"
										className={!isValid.maxbrDl ? 'is-invalid' : ''}
									/>
									{!isValid.maxbrDl && (
										<div className="invalid-feedback">
											{validationRules.maxbrDl.errorMessage}
										</div>
									)}
								</InputGroup>
							</div>
						)}

						{formData?.qosData?.gbrUl?.active && (
							<div className="col-xs-12 col-lg-4">
								<label htmlFor="idActionQoSGuaUP">Guaranteed BR Upload</label>
								<InputGroup className="mb-3">
									<Form.Control
										name="gbrUl"
										value={formData?.qosData?.gbrUl?.value}
										required={formData?.qosData?.gbrUl?.active}
										onChange={e => handleChange(['qosData', 'gbrUl'], e)}
										onInput={(e: ChangeEvent<HTMLInputElement>) => {
											const {name} = e.target;
											const target = e.target as unknown as HTMLInputElement;
											const val = target.value;
											target.value = val;
											const rule = validationRules[name as never] as any;
											const result = rule.regex.test(val);
											setIsValid(prev => ({
												...prev,
												[name]: result,
											}));
											onObserver(result);
										}}
										aria-label="gbrUl"
										placeholder="Ej: 128 Mbps, $gbrUl o $math(...)"
										className={!isValid.gbrUl ? 'is-invalid' : ''}
									/>
									{!isValid.gbrUl && (
										<div className="invalid-feedback">
											{validationRules.gbrUl.errorMessage}
										</div>
									)}
								</InputGroup>
							</div>
						)}

						{formData?.qosData?.gbrDl?.active && (
							<div className="col-xs-12 col-lg-4">
								<label htmlFor="idActionQoSGuaDo">Guaranteed BR Download</label>
								<InputGroup className="mb-3">
									<Form.Control
										name="gbrDl"
										value={formData?.qosData?.gbrDl?.value}
										required={formData?.qosData?.gbrDl?.active}
										onChange={e => handleChange(['qosData', 'gbrDl'], e)}
										onInput={(e: ChangeEvent<HTMLInputElement>) => {
											const {name} = e.target;
											const target = e.target as unknown as HTMLInputElement;
											const val = target.value;
											target.value = val;
											const rule = validationRules[name as never] as any;
											const result = rule.regex.test(val);
											setIsValid(prev => ({
												...prev,
												[name]: result,
											}));
											onObserver(result);
										}}
										aria-label="gbrDl"
										placeholder="Ej: 128 Mbps, $gbrDl o $math(...)"
										className={!isValid.gbrDl ? 'is-invalid' : ''}
									/>
									{!isValid.gbrDl && (
										<div className="invalid-feedback">
											{validationRules.gbrDl.errorMessage}
										</div>
									)}
								</InputGroup>
							</div>
						)}

						{(formData?.qosData?.arp?.priorityLevel?.active ||
							formData?.qosData?.arp?.preemptCap?.active ||
							formData?.qosData?.arp?.preemptVuln?.active) && (
							<FieldSetSumma title="ARP">
								<div className="row">
									{formData?.qosData?.arp?.priorityLevel?.active && (
										<div className="col-12 col-sm-6 col-lg-2">
											<label
												htmlFor="idActionARPPriorityLevel"
												className="text-nowrap d-inline-block"
												style={{minWidth: '7.25rem'}}>
												Priority Level
											</label>
											<InputGroup
												className="mb-3 w-100"
												style={{minWidth: '5rem'}}>
												<Form.Control
													type="number"
													onInput={e => {
														const target = e.target as HTMLInputElement;
														target.value = target.value.slice(0, 15);
													}}
													name="priorityLevel"
													value={formData?.qosData?.arp?.priorityLevel?.value}
													required={
														formData?.qosData?.arp?.priorityLevel?.active
													}
													onChange={e =>
														handleChange(['qosData', 'arp', 'priorityLevel'], e)
													}
													className="w-100"
													aria-label="priorityLevel"
												/>
											</InputGroup>
										</div>
									)}

									{formData?.qosData?.arp?.preemptCap?.active && (
										<div className="col-xs-12 col-sm-6 col-lg-5">
											<label htmlFor="idActionARPPreEmptionCap">
												Pre-emption Capability
											</label>
											<InputGroup
												className="mb-3 w-100"
												style={{minWidth: '6rem'}}>
												<Form.Select
													name="preemptCap"
													value={formData?.qosData?.arp?.preemptCap?.value}
													required={formData?.qosData?.arp?.preemptCap?.active}
													onChange={e =>
														handleChange(['qosData', 'arp', 'preemptCap'], e)
													}
													aria-label="preemptCap">
													<option disabled value="">
														Select...
													</option>
													<option value="MAY_PREEMPTABLE">
														MAY_PREEMPTABLE
													</option>
													<option value="NOT_PREEMPTABLE">
														NOT_PREEMPTABLE
													</option>
												</Form.Select>
											</InputGroup>
										</div>
									)}

									{formData?.qosData?.arp?.preemptVuln?.active && (
										<div className="col-xs-12 col-sm-6 col-lg-5">
											<label htmlFor="idActionARPPreEmptionVulne">
												Pre-emption Vulnerability
											</label>
											<InputGroup
												className="mb-3 w-100"
												style={{minWidth: '6rem'}}>
												<Form.Select
													name="preemptVuln"
													value={formData?.qosData?.arp?.preemptVuln?.value}
													required={formData?.qosData?.arp?.preemptVuln?.active}
													onChange={e =>
														handleChange(['qosData', 'arp', 'preemptVuln'], e)
													}
													aria-label="preemptVuln">
													<option disabled value="">
														Select...
													</option>
													<option value="NOT_PREEMPTABLE">
														NOT_PREEMPTABLE
													</option>
													<option value="PREEMPTABLE">PREEMPTABLE</option>
												</Form.Select>
											</InputGroup>
										</div>
									)}
								</div>
							</FieldSetSumma>
						)}
					</div>
				)}

				{(formData?.chargingParameter?.online?.active ||
					formData?.chargingParameter?.offline?.active ||
					formData?.chargingParameter?.chargingInfo?.primaryChfAddress
						?.active ||
					formData?.chargingParameter?.chargingInfo?.secondaryChfAddress
						?.active) && (
					<div className="row">
						<div className="col-lg-12 bg-gray-400 rounded pt-1 pb-1 mt-2 mb-2 text-center">
							<b>Charging Parameters</b>
						</div>
						{formData?.chargingParameter?.online?.active && (
							<div className="col-xs-12 col-lg-3">
								<label
									htmlFor="idActionChargingOnline"
									className="font-weight-bold">
									Online
								</label>
								<InputGroup className="mb-3">
									<Form.Check
										name="online"
										checked={formData?.chargingParameter?.online?.value}
										required={formData?.chargingParameter?.online?.active}
										type="switch"
										data-switch="true"
										id="custom-switch-chargingParameter"
										className="custom-switch-lg custom-switch-position-relative"
										onChange={e =>
											handleChange(['chargingParameter', 'online'], e)
										}
									/>
								</InputGroup>
							</div>
						)}

						{formData?.chargingParameter?.offline?.active && (
							<div className="col-xs-12 col-lg-3">
								<label
									htmlFor="idActionChargingOffline"
									className="font-weight-bold">
									Offline
								</label>
								<InputGroup className="mb-3">
									<Form.Check
										name="offline"
										checked={formData?.chargingParameter?.offline?.value}
										required={formData?.chargingParameter?.offline?.active}
										type="switch"
										data-switch="true"
										id="custom-switch-chargingParameter"
										className="custom-switch-lg custom-switch-position-relative"
										onChange={e =>
											handleChange(['chargingParameter', 'offline'], e)
										}
									/>
								</InputGroup>
							</div>
						)}

						{formData?.chargingParameter?.chargingInfo?.primaryChfAddress
							?.active && (
							<div className="col-xs-12 col-lg-6">
								<label htmlFor="idActionChargingPrimaryChf">
									Primary Chf Address
								</label>
								<InputGroup className="mb-3">
									<Form.Control
										name="primaryChfAddress"
										value={
											formData?.chargingParameter?.chargingInfo
												?.primaryChfAddress?.value
										}
										required={
											formData?.chargingParameter?.chargingInfo
												?.primaryChfAddress?.active
										}
										onChange={e =>
											handleChange(
												[
													'chargingParameter',
													'chargingInfo',
													'primaryChfAddress',
												],
												e,
											)
										}
										aria-label="primaryChfAddress"
									/>
								</InputGroup>
							</div>
						)}

						{formData?.chargingParameter?.chargingInfo?.secondaryChfAddress
							?.active && (
							<div className="col-xs-12 col-lg-6">
								<label htmlFor="idActionChargingSecondaryChf">
									Secondary Chf Address
								</label>
								<InputGroup className="mb-3">
									<Form.Control
										name="secondaryChfAddress"
										value={
											formData?.chargingParameter?.chargingInfo
												?.secondaryChfAddress?.value
										}
										required={
											formData?.chargingParameter?.chargingInfo
												?.secondaryChfAddress?.active
										}
										onChange={e =>
											handleChange(
												[
													'chargingParameter',
													'chargingInfo',
													'secondaryChfAddress',
												],
												e,
											)
										}
										aria-label="secondaryChfAddress"
									/>
								</InputGroup>
							</div>
						)}
					</div>
				)}

				{formData?.monitoringKey?.active && (
					<div className="row">
						<div className="col-lg-12 bg-gray-400 rounded pt-1 pb-1 mt-2 mb-2 text-center">
							<b>Data</b>
						</div>
						{formData?.monitoringKey?.active && (
							<div className="col-xs-12 col-lg-6">
								<label htmlFor="idActionDataMonitoringKey">
									Monitoring Key
								</label>
								<InputGroup className="mb-3">
									<Form.Control
										name="monitoringKey"
										value={formData?.monitoringKey?.value}
										required={formData?.monitoringKey?.active}
										onChange={e => handleChange(['monitoringKey'], e)}
										aria-label="monitoringKey"
									/>
								</InputGroup>
							</div>
						)}
					</div>
				)}

				{formData?.terminate?.active && (
					<div className="row">
						<div className="col-lg-12 bg-gray-400 rounded pt-1 pb-1 mt-2 mb-2 text-center">
							<b>Final Actions</b>
						</div>
						{formData?.terminate?.active && (
							<div className="col-xs-12 col-lg-6">
								<label
									htmlFor="idActionSpecialTerminate"
									className="font-weight-bold">
									Terminate
								</label>
								<InputGroup className="mb-3">
									<Form.Check
										name="terminate"
										checked={formData?.terminate?.value}
										required={formData?.terminate?.active}
										type="switch"
										data-switch="true"
										id="custom-switch-terminate"
										className="custom-switch-lg custom-switch-position-relative"
										onChange={e => handleChange(['terminate'], e)}
									/>
								</InputGroup>
							</div>
						)}
					</div>
				)}

				{formData?.sms?.active && (
					<div className="row">
						<div className="col-lg-12 bg-gray-400 rounded pt-1 pb-1 mt-2 mb-2 text-center">
							<b>Special Actions</b>
						</div>
						{formData?.sms?.active && (
							<div className="col-xs-12 col-lg-12">
								<label htmlFor="idActionSpecialSendSMS">Send SMS</label>
								<InputGroup className="mb-3">
									<Form.Control
										as="textarea"
										name="sms"
										value={formData?.sms?.value}
										required={formData?.sms?.active}
										onChange={e => handleChange(['sms'], e)}
										aria-label="sms"
										rows={4}
									/>
								</InputGroup>
							</div>
						)}
					</div>
				)}

				{formData?.hasResetSMS && (
					<div className="row">
						<div className="col-lg-12 bg-gray-400 rounded pt-1 pb-1 mt-2 mb-2 text-center">
							<b>Reset SMS</b>
						</div>
						<div className="col m-3">
							<Button
								onClick={onAddResetSMS}
								type="button"
								variant="secondary"
								className="btn btn-labeled btn-sm z-index mr-1">
								<span className="btn-label mr-2">
									<i className="bi-1 bi-plus" />
								</span>
								Add Name Policy
							</Button>
						</div>
						{formData?.resetSMS?.map(
							(resetSMSVar: IResetSMSForm, index: number) => (
								<FieldSetSumma title={`Policy #${index + 1}`} key={index}>
									<div>
										<OverlayTrigger
											overlay={
												<Tooltip id="tooltip-disabled">
													{`Delete Name Policy #${index + 1}`}
												</Tooltip>
											}>
											<button
												onClick={() => handleResetSMSRemove(resetSMSVar.id)}
												type="button"
												className="border-0 bg-transparent d-inline position-absolute top-0 end-0 pr-2 mt-n3"
												data-bs-toggle="collapse"
												data-bs-target="#newresetSMS1"
												aria-expanded="true">
												<i
													className="bi-1 bi-trash3-fill invalid-color"
													title=""
													data-toggle="tooltip"
													data-original-title="Delete"
												/>
											</button>
										</OverlayTrigger>
									</div>
									<div className="row">
										<div className="col-xs-12 col-lg-12">
											<label htmlFor="">{`Name Policy #${index + 1}`}</label>
											<InputGroup className="mb-3">
												<Form.Control
													name="namePolicy"
													aria-label="namePo"
													value={resetSMSVar?.resetSMS?.value}
													required
													placeholder="Name Policy"
													onChange={e =>
														handleChange(
															['resetSMS', 'resetSMS'],
															e,
															resetSMSVar.id,
														)
													}
												/>
											</InputGroup>
										</div>
									</div>
								</FieldSetSumma>
							),
						)}
					</div>
				)}

				{formData?.hasRuleStatic && (
					<div className="row">
						<div className="col-lg-12 bg-gray-400 rounded pt-1 pb-1 mt-2 mb-2 text-center">
							<b>Rule Static</b>
						</div>
						<div className="col m-3">
							<Button
								type="button"
								variant="secondary"
								className="btn btn-labeled btn-sm z-index mr-1"
								onClick={onAddRuleStatic}>
								<span className="btn-label mr-2">
									<i className="bi-1 bi-plus" />
								</span>
								Add Rule Static
							</Button>
						</div>
						{formData?.pccRuleStatic?.map(
							(ruleStatic: IPccRuleFormStatic, index: number) => (
								<FieldSetSumma title={`Rule Static #${index + 1}`} key={index}>
									<div>
										<button
											onClick={() => handleRuleStaticRemove(ruleStatic.id)}
											type="button"
											className="border-0 bg-transparent d-inline position-absolute top-0 end-0 pr-2 mt-n3"
											data-bs-toggle="collapse"
											data-bs-target="#newrulestatic1"
											aria-expanded="true">
											<i
												className="bi-1 bi-trash3-fill invalid-color"
												title=""
												data-toggle="tooltip"
												data-original-title="Delete"
											/>
										</button>
									</div>
									<div className="row">
										<div className="col-xs-2 col-lg-2">
											<label
												htmlFor="idActionSpecialCRBN"
												className="font-weight-bold">
												CRBN
											</label>
											<InputGroup className="mb-3">
												<Form.Check
													name="crbn"
													checked={ruleStatic?.pccRuleId?.crbn?.value}
													type="switch"
													data-switch="true"
													id="custom-switch-crbn"
													className="custom-switch-lg custom-switch-position-relative"
													onChange={e =>
														handleChange(
															['pccRuleStatic', 'pccRuleId', 'crbn'],
															e,
															ruleStatic.id,
														)
													}
												/>
											</InputGroup>
										</div>
										<div className="col-xs-10 col-lg-10">
											<label htmlFor="idActionRuleStatic">Id</label>
											<InputGroup className="mb-3">
												<Form.Control
													name="pccRuleId"
													value={ruleStatic?.pccRuleId?.pccRuleId?.value}
													required
													onChange={e =>
														handleChange(
															['pccRuleStatic', 'pccRuleId', 'pccRuleId'],
															e,
															ruleStatic.id,
														)
													}
													aria-label="_"
													placeholder="PccRuleId CBR"
												/>
											</InputGroup>
										</div>
									</div>
								</FieldSetSumma>
							),
						)}
					</div>
				)}
			</div>
			{/* end 1 row*/}
		</>
	);
};

export default CustomSelectionItemCondition;
